import { ArtistsGrid } from "@components/artists_grid/artists_grid";
import { Loader } from "@components/loader/loader";
import { ArtistsProvider } from "@contexts/artists_context";
import { useFetchArtists } from "@hooks/use_fetch_artists";
import { isEmpty } from "@services/helpers";
import { isNil, sample } from "@services/typed_helpers";
import React, { FC } from "react";

const NUM_ARTISTS = 16;
const HomePageArtists: FC = () => {
  const { artists: allArtists, loading } = useFetchArtists();
  if (loading) {
    return <Loader />;
  }
  if (isNil(allArtists) || isEmpty(allArtists)) {
    return null;
  }
  const sampledArtists = sample(allArtists, NUM_ARTISTS);
  return (
    <ArtistsProvider artists={sampledArtists || []}>
      <ArtistsGrid includeNames={true} />
    </ArtistsProvider>
  );
};

export { HomePageArtists };
